import { useTranslations } from '@vocab/react';
import {
  Box,
  Button,
  IconMail,
  IconSocialFacebook,
  IconSocialLinkedIn,
  IconSocialX,
  MenuRenderer,
  MenuItem,
  IconCopy,
} from 'braid-design-system';

import useShareHandler from 'src/hooks/useShareHandler/useShareHandler';

import translations from './.vocab';

import * as styles from './ShareButton.css';

interface ShareButtonProps {
  shareLink: string;
  onShare?: (channel: string) => void;
}

export default ({ shareLink, onShare }: ShareButtonProps) => {
  const { t } = useTranslations(translations);
  const onFbClick = useShareHandler({
    channel: 'facebook',
    url: shareLink,
  });

  const onXClick = useShareHandler({
    channel: 'twitter',
    url: shareLink,
  });

  const onLinkedInClick = useShareHandler({
    channel: 'linkedin',
    url: shareLink,
  });

  const onCopyLinkClick = () => navigator.clipboard.writeText(shareLink);

  const emailSubject = 'I found you a nice thread on SEEK!';
  const emailBody = `Hey,\n\nI found this thread via SEEK and thought of you.\n\n${shareLink}`;
  const emailShareLink = `mailto:%20?subject=${encodeURIComponent(
    emailSubject,
  )}&body=${encodeURIComponent(emailBody)}`;
  const onEmailClick = useShareHandler({
    channel: 'email',
    url: emailShareLink,
  });

  return (
    <Box borderRadius="full" className={styles.ShareButtonContainer}>
      <MenuRenderer
        align="left"
        offsetSpace="xsmall"
        trigger={(triggerProps) => (
          <Button
            id="OptionsDropdownMenuButton"
            variant="soft"
            tone="formAccent"
            size="standard"
            data={{ automation: 'option-drop-down-menu' }}
            {...triggerProps}
          >
            {t('share')}
          </Button>
        )}
      >
        <MenuItem
          icon={<IconMail />}
          onClick={() => {
            onEmailClick();
            onShare?.('Email');
          }}
        >
          Email
        </MenuItem>
        <MenuItem
          icon={<IconSocialFacebook />}
          onClick={() => {
            onFbClick();
            onShare?.('Facebook');
          }}
        >
          Facebook
        </MenuItem>
        <MenuItem
          icon={<IconSocialX />}
          onClick={() => {
            onXClick();
            onShare?.('X');
          }}
        >
          Twitter
        </MenuItem>
        <MenuItem
          icon={<IconSocialLinkedIn />}
          onClick={() => {
            onLinkedInClick();
            onShare?.('LinkedIn');
          }}
        >
          LinkedIn
        </MenuItem>
        <MenuItem
          icon={<IconCopy />}
          onClick={() => {
            onCopyLinkClick();
            onShare?.('Copy link');
          }}
        >
          {t('copylink')}
        </MenuItem>
      </MenuRenderer>
    </Box>
  );
};
